// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"styles_searchInputWrapper__gzF4w"};